import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';
import {
    OrderGuideServiceProxy,
    VirtualBankAccountDto,
    PagedResultDtoOfVirtualBankAccountDto,
    FieldTypes
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import moment from 'moment';

import { SearchAndSelectComponent } from
    '@app/shared/common/shop-system/common/search-and-select/search-and-select.component';
import { ColumnDefinition } from '@app/shared/common/shop-system/models/models';
import { IColumnDefinition } from '@app/shared/common/shop-system/models/models';

@Component({
    selector: 'app-shop-search-and-select-customers',
    templateUrl: './search-and-select-customers.component.html',
    styleUrls: ['./search-and-select-customers.component.less']
})
export class SearchAndSelectCustomersComponent extends AppComponentBase implements OnInit {

    //#region initialization Basic SearchAndSelectComponent
    //create dynamic SearchAndSelectComponent depends on Provided type
    private _searchAndSelectCustomer: SearchAndSelectComponent<VirtualBankAccountDto>;
    @ViewChild('appSearchAndSelectComponent')
    set searchAndSelectArticle(value: SearchAndSelectComponent<VirtualBankAccountDto>) {
        this._searchAndSelectCustomer = value;
        //set instance of class to define which property he need s to show
        this._searchAndSelectCustomer.instance = VirtualBankAccountDto.fromJS({});
        //set specific property to show that overrides default columns depends on instance of provided Class(Type)

        let columns: ColumnDefinition[] = [
            { field: 'legalName', header: 'LegalName', sorting: true, type: FieldTypes.Text },
            { field: 'contactName', header: 'ContactName', sorting: true, type: FieldTypes.Text },
            { field: 'userName', header: 'UserName', sorting: true, type: FieldTypes.Text },
            { field: 'invoiceEAddress', header: 'Email', sorting: true, type: FieldTypes.Text }
        ];
        this._searchAndSelectCustomer.columns = columns;
    }
    //#endregion

    @Input() orderGuideId: string;

    @Output() onChangeCustomers: EventEmitter<any> = new EventEmitter<any>();

    selectedCustomers: VirtualBankAccountDto[] = [];

    private _customers: VirtualBankAccountDto[] = [];
    set customers(value: VirtualBankAccountDto[]) {
        if (!value) {
            this._customers = [];
        }

        this._customers = value;
    }
    get customers(): VirtualBankAccountDto[] {
        return this._customers;
    }

    private _total: number = 0;
    set total(value: number) {
        if (!value) {
            this._total =0;
        }

        this._total = value;
    }
    get total(): number {
        return this._total;
    }

    private _searchString: string;
    set searchString(value: string) {
        this._searchString = value;
    }
    get searchString(): string {
        return this._searchString;
    }

    get excludeOrderGuideId(): string {
        return this.orderGuideId;
    }

    id: string;

    constructor(
        injector: Injector,
        private _orderGuideServiceProxy: OrderGuideServiceProxy,
        private _activatedRoute: ActivatedRoute
    ) {
        super(injector);


        this.id = this._activatedRoute.snapshot.params['id'];
    }

    ngOnInit(): void {
        this.getCustomers();
    }

    onSearchChange(searchString: string) {
        this.searchString = searchString;
        this.getCustomers();
    }

    getCustomers() {
        if (this._searchAndSelectCustomer) {
            this._searchAndSelectCustomer.primengTableHelper.showLoadingIndicator();
            this._orderGuideServiceProxy.getAvailableCustomersForOrderGuide(
                    this.searchString || undefined,
                    this.excludeOrderGuideId || this.id || undefined,
                    undefined, 0, 10)
                .subscribe((customers: PagedResultDtoOfVirtualBankAccountDto) => {
                    this.customers = customers.items;
                    this.total = customers.totalCount;
                    this._searchAndSelectCustomer.primengTableHelper.hideLoadingIndicator();
                });
        }
    }

    onPagination(pagination) {
        if (this._searchAndSelectCustomer) {
            this._searchAndSelectCustomer.primengTableHelper.showLoadingIndicator();
            this._orderGuideServiceProxy.getAvailableCustomersForOrderGuide(
                    this.searchString || undefined,
                    this.excludeOrderGuideId || this.id || undefined,
                    pagination.sorting || undefined,
                    pagination.skipCount || 0,
                    pagination.maxResultCount || 10)
                .subscribe((customers: PagedResultDtoOfVirtualBankAccountDto) => {
                    this.customers = customers.items;
                    this.total = customers.totalCount;
                    this._searchAndSelectCustomer.primengTableHelper.hideLoadingIndicator();
                });
        }
    }

    onRowSelect($event) {
        this.onChangeCustomers.emit($event);
    }
    onRowUnselect($event) {
        this.onChangeCustomers.emit($event);
    }
}
